module.exports = __webpack_public_path__ + "img/01-memu-bar_m.304123ac.png";